<template>
  <div class="centerArea_wrapper">
    <div class="theater-message-wrapper">
      <div class="videoParts_wrapper">
        <div class="videoParts_inner">
          <div class="videoPlayer">
            <div class="videoPlayer_wrapper" :class="{'no-mask': room.video_content_id, 'no-playbtn': room.video_content_id}">
              <YouTubeManager v-if="isYouTubeRoom" :video-content-id="room.video_content_id" :play-video="playingVideo" />
              <VimeoManager
                v-if="isVimeoRoom"
                :video-content-id="room.video_content_id"
                :play-video="playingVideo"
                :questionnaire-settings="room.questionnaire_settings"
                :disable-start-button-questionnaire-ids="room.questionnaires.map(questionnaire => questionnaire.id)"
                :slug="room.slug"
              />
              <JStreamManager v-if="isJStreamRoom" :video-content-id="room.video_content_id" :play-video="playingVideo" />
              <VimeoManager
                v-if="isVimeoLiveRoom"
                :video-content-id="room.video_content_id"
                :is-live="true"
                :play-video="playingVideo"
                :questionnaire-settings="room.questionnaire_settings"
                :disable-start-button-questionnaire-ids="room.questionnaires.map(questionnaire => questionnaire.id)"
                :slug="room.slug"
                :start-at="room.video_start_at"
              />
              <div v-if="hasNoContent" class="player"></div>
              <Thumbnail
                v-if="room.video_content_id && showThumbnail"
                :page="room"
                @play-video="playVideo"
                :style="{cursor: room.video_content_id === null ? 'initial' : 'pointer'}"
              />
            </div>
          </div>
        </div>
      </div>
      <RoomMessageColumn :room-name="room.name" v-if="room.display_chat" />
    </div>
    <div class="videoTitle_wrapper wrapper hard">
      <div class="videoTitle_inner flex_center">
        <div class="flex_center">
          <div class="extBtn_wrapper">
            <router-link :to="{name: 'Hall', params: {hallSlug: $route.params.hallSlug}}" class="ext_btn flex_center inner light btn">
              <fa-icon icon="sign-out-alt" />
              <span>退出する</span>
            </router-link>
          </div>
          <h2 class="videoTitle inner light">
            <span>{{ room.name }}</span>
          </h2>
        </div>
      </div>
      <div class="videoTxt_wrapper wrapper background" v-if="!_.isEmpty(room.description)">
        <p>
          <RawHtml :text="room.description" />
        </p>
      </div>
      <Participants :participants="$store.getters['participants/getByHallAndRoomSlug']($route.params.hallSlug, room.slug)" />
    </div>
  </div>
</template>

<script>
import Participants from "../elements/Participants"
import RawHtml from "../elements/RawHtml"
import RoomMessageColumn from "../modules/RoomMessageColumn"
import Thumbnail from "../elements/Thumbnail"
import JStreamManager from "../modules/JStreamManager"
import YouTubeManager from "../modules/YouTubeManager"
import VimeoManager from "../modules/VimeoManager"

export default {
  name: "TRoom",
  components: {
    Thumbnail,
    RoomMessageColumn,
    Participants,
    RawHtml,
    JStreamManager,
    YouTubeManager,
    VimeoManager
  },
  props: {
    hallSlug: {
      type: String,
      required: false,
      default: ""
    },
    roomSlug: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      showThumbnail: true,
      playingVideo: false,
      youtube: 1,
      vimeo: 2,
      jStream: 3
    }
  },
  computed: {
    room: function() {
      return this.$store.getters["room/getBySlug"](this.roomSlug)
    },
    gteMaxJoinCount: vm => (hallSlug, roomSlug, maxJoinCount) => {
      if (maxJoinCount === null) return false

      return vm.$store.getters["participants/countByHallAndRoomSlug"](hallSlug, roomSlug) >= maxJoinCount
    },
    isYouTubeRoom() {
      if (_.isEmpty(this.room.video_content_id)) return false

      return this.room.video_service_type === 1
    },
    isVimeoRoom() {
      if (_.isEmpty(this.room.video_content_id)) return false

      return this.room.video_service_type === 2
    },
    isJStreamRoom() {
      if (_.isEmpty(this.room.video_content_id)) return false

      return this.room.video_service_type === 3
    },
    isVimeoLiveRoom() {
      if (_.isEmpty(this.room.video_content_id)) return false

      return this.room.video_service_type === 4
    },
    hasNoContent() {
      return _.isNull(this.room.video_content_id)
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
  },
  beforeRouteUpdate(to, from, next) {
    this.playingVideo = false
    next()
  },
  methods: {
    handleResize() {
      if (window.innerWidth <= 992) {
        this.$store.commit("sideMenu/collapseByLeft", false)
        this.$store.commit("sideMenu/collapseByRight", false)
      } else {
        return
      }
    },
    playVideo() {
      if (this.hasNoContent) return

      this.showThumbnail = false

      this.$axios
        .post(`events/${this.$route.params.slug}/action_logs`, {
          type: 1, // Enums\ActionLog\Type::VIDEO
          whereable_id: this.room.id,
          whereable_type: "rooms",
          url: this.$route.path
        })
        .then(response => {
          return true
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      this.playingVideo = true
    }
  }
}
</script>
